export enum BusinessUnitTypeEnum {
    CustomerServiceOffice = 1,
    LECU = 2,
    Enforcement = 3,
    MedicalReview = 4,
    CDL = 5,
    MotorCarrier = 6,
    PDS = 7,
    DriverServices = 8,
    MVMSupport = 9,
    CallCenter = 10,
    ThirdPartyOffice = 11,
    PortOfEntry = 12,
    MVDSupport = 13,
    Finance = 14,
    Kiosk = 15,
    OOFCustServiceOffice = 18
}
